import React, { useContext } from 'react';
import QuestionCard from './QuestionCard';
import { DndProvider } from 'react-dnd';
import {HTML5Backend} from "react-dnd-html5-backend";
import { AppContext } from '../RoundRegContext';

const QuestionCardList = ({qList}) => {

    const {dragListChangeQuestion, handleQuestionInputChange, handleQuestionCopyFields, handleQuestionRemoveFields} = useContext(AppContext);

    return (
        <DndProvider backend={HTML5Backend}>
            <ul className="faq-card-group">
                {qList.map((qst, index) => (
                    <QuestionCard 
                        key={index} 
                        index={qst.order}
                        idx={index}
                        question={qst}
                        moveCard={dragListChangeQuestion}
                        handleQuestionInputChange={handleQuestionInputChange}
                        handleQuestionCopyFields={handleQuestionCopyFields}
                        handleQuestionRemoveFields={handleQuestionRemoveFields}

                    />
                ))}
            </ul>
        </DndProvider>
    );
};

export default QuestionCardList;